import Vuex from 'vuex';
import Vue from 'vue';
import axios from 'axios';

Vue.use(Vuex)

import VuexPersist from 'vuex-persist'
const vuexPersist = new VuexPersist({
  key: 'otp',
  storage: localStorage
})

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fields: {},
    protocolHash: null,
    protocolStatus: null,
    images: null,
    protocol: null,
    errorMessage: null
  },
  mutations: {
    setProtocolHash(state, value) {
      state.protocolHash = value;
    },
    setProtocolstatus(state, value) {
      state.protocolStatus = value;
    },
    setImages(state, value) {
      state.images = value;
    },
    setProtocol(state, value) {
      state.protocol = value;
    },
    setOnline(state, value) {
      state.online = value;
    },
    saveProtocolToServer(state, value) {
      axios
        .put(process.env.VUE_APP_PROTOCOL_API + 'protocols/' + state.protocolHash, state.protocol.saved_values)
        .then(response => {
          if (response.data.length == 0) {
            console.log('Error putting to server');
          }
        })
        .catch(error => {
          console.log(error);
        })
    },
    setErrorMessage(state, value) {
      state.errorMessage = value
    }
  },
  plugins: [vuexPersist.plugin]
})